/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/solid'
import { Link } from 'react-router-dom'

export default function SideNav(props) {
  const [open, setOpen] = useState(true)
  const handleLogOut = async () => {    
    await props.logUserOut();
    props.setShowSideNav(false);
  }
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => props.setShowSideNav(false)}>
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col overflow-y-scroll bg-black text-white py-6 shadow-xl">
                    <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-lg font-medium text-gray-900"> </Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="rounded-md bg-black text-white hover:text-gray-500"
                            onClick={() => props.setShowSideNav(false)}
                          >
                            <span className="sr-only">Close panel</span>
                            <XIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6">
                      <div className="mt-44">
                        <div className="mb-20"><Link  onClick={() => props.setShowSideNav(false)} to="/mysounds"><h1 className="text-3xl font-serif">My SoundBasket</h1></Link></div>
                        <div className="mb-20"><Link onClick={() => props.setShowSideNav(false)} to="/discover"><h1 className="text-3xl font-serif">Discover</h1></Link></div>
                        <div className="mb-20"><Link onClick={() => props.setShowSideNav(false)} to="/artist"><h1 className="text-3xl font-serif">Set Up Artist NFT</h1></Link></div>
                        {props.accessToken && <div className="mb-20"><button onClick={handleLogOut} to="/auth"><h1 className="text-3xl font-serif">Log Out</h1></button></div>}
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
